import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ConstantsService } from './constants.service';

@Injectable({ providedIn: 'root' })
export class BrandMetadataService {
  private readonly imageByBrand: Readonly<Record<string, string>>;

  constructor(
    private readonly meta: Meta,
    constants: ConstantsService
  ) {
    this.imageByBrand = {
      [constants.STARKEY_SUB_DOMAIN]: 'assets/icons/MyStarkeyText.png',
      [constants.AUDIBEL_SUB_DOMAIN]: 'assets/icons/MyAudibelText.png',
      [constants.HEAR_CIRCLE_SUB_DOMAIN]: 'assets/icons/HearCircleText.png',
      [constants.KIND_SUB_DOMAIN]: 'assets/icons/KindText.png',
      [constants.SOUNDGEAR_SUB_DOMAIN]: 'assets/icons/MySoundGearText.png',
      [constants.PHANTOM_SUB_DOMAIN]: 'assets/icons/MyPhantomText.png'
    };
  }

  setOpenGraphImage(brand: string): void {
    const content = this.imageByBrand[brand];
    if (content) {
      this.meta.updateTag({ property: 'og:image', content }, 'property="og:image"');
    }
  }
}
